module.exports = __webpack_public_path__ + "img/EgyptTechChariotArcher3_ua.1ae92612.webp";